// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".choose-budget-container .content-area{min-height:calc(100vh - 60px)}.choose-budget-container .content-area .txt{font-size:14px;margin-bottom:10px;margin-top:20px;color:#51606d}.choose-budget-container .buttons{display:flex;flex-direction:row-reverse;margin-top:60px;margin-bottom:50px}.choose-budget-container .buttons #btn-choose-budget{margin-left:15px}\n", ""]);
// Exports
module.exports = exports;
